.pip {
	position: absolute;
	right: var(--m-sp-md);
	top: var(--m-sp-md);
	width: --fn-literal(8px);
	height: --fn-literal(8px);
	border-radius: 50%;
	@apply --mx-bg(var(--m-accent));
}

.desktopOnly {
	display: none;

	@media (min-width: 1024px) {
		display: flex;
	}
}

.changelogItem {
	&[data-new='true'] {
		@apply --mx-bg(var(--m-accent-wash));
		@apply --mx-fg(var(--m-accent-heavy));
	}
}
